export const ONBOARDING_PATH = '/app/solar-panels/onboarding';

/** Backend sets firstLogIn to 1 on the first successful OTP login (new or never-logged-in account). */
export function isFirstLogin(user) {
  return !!user && user.firstLogIn === 1;
}

/** Onboarding URL that returns the user to `returnPath` when finished. */
export function getOnboardingPath(returnPath) {
  return returnPath
    ? `${ONBOARDING_PATH}?redirect=${encodeURIComponent(returnPath)}`
    : ONBOARDING_PATH;
}
